const Backbone = require('backbone');
const RecommendedOptionFinishesCollection = require('collections/product/recommendedoptionfinishes');
var RecommendedOptionsModel = Backbone.Model.extend({
	defaults: {
		configured: false,
		isNeeded: true
	},

	initialize: function() {
		let finishes = [];

		this.get('products').forEach((product) => {
			const productFinishes = product.finishes || [];
			finishes = finishes.concat(
				productFinishes.map((finish) => {
					return Object.assign(finish, {
						manufacturer: product.manufacturer,
						productId: product.productId,
						productCompositeId: product.productCompositeId
					});
				})
			);
		});

		this.set('finishes', finishes);

		this.finishes = new RecommendedOptionFinishesCollection(finishes);
		this.listenTo(Backbone, 'recommendedOptionFinish:clicked', this._optionsChanged);
		this.listenTo(Backbone, 'finish:clicked', this.matchSelectedFinish);
	},

	matchSelectedFinish: function(data) {
		var self = this,
			finishName = data.name,
			selectedFinish,
			matchedFinish;
		selectedFinish = self.getSelected()[0];
		matchedFinish = self.finishes.findWhere({
			finish: finishName
		});
		if (matchedFinish && selectedFinish && !selectedFinish.get('manuallySelected')) {
			selectedFinish.set({
				selected: false
			});
			matchedFinish.set({
				selected: true
			});
			Backbone.trigger('recommendedOptionFinish:change');
		}
	},

	/**
	 * getSelected - Find the recommended options that are selected
	 * @return {Array} Recommended Option models that are selected
	 */
	getSelected: function() {
		return this.finishes.where({
			selected: true
		});
	},

	/**
	 * getQuantity - Get quantity of recommended option
	 */
	getQuantity: function() {
		return this.get('quantity');
	},

	getFinishByUniqueId: function(uniqueId) {
		return this.finishes.findWhere({
			uniqueId: uniqueId
		});
	},

	getProductWithFinishUniqueId: function(uniqueId) {
		var matchedProduct;
		this.get('products').forEach((product) => {
			const finishes = product.finishes,
				match = finishes.find((finish) => finish.uniqueId === parseInt(uniqueId, 10));
			if (match) {
				matchedProduct = product;
			}
		});
		return matchedProduct;
	},

	/**
	 * isConfigured - Shortcut to determine if this recommended option is considered configured
	 * @return {Boolean} If the recommended option is configured
	 */
	isConfigured: function() {
		return this.get('configured');
	},

	/**
	 * _optionsChanged Event callback when child models (recommended options) change
	 * @private
	 */
	_optionsChanged: function() {
		var selectedFinish = this.finishes.where({
			selected: true
		});

		this.set('configured', selectedFinish.length > 0);
	}
});

module.exports = RecommendedOptionsModel;
